import { connect } from "react-redux";
import { ThunkDispatch } from "redux-thunk";

import { ApplicationState } from "../../../store/ApplicationState";
import { getHealthPlanMasterResp, getRoles, getUsers, updateUserStatus } from "../../../actions/Users";
import UserManagement from "../components/UserManagement";
import { UserSearchPayload, UserStatusPayload } from "../../../models/User";

const mapStateToProps = ({userState, roleState,healthPlanMasterState,updateUserStatusState}: ApplicationState) => ({
  userData: userState.userData,
  roles: roleState.response,
  healthPlanMaster: healthPlanMasterState.response,
  updateUserStatusResponse: updateUserStatusState.response,
  updateUserStatusLoading: updateUserStatusState.loading,
});

const mapDispatchToProps = (
    dispatch: ThunkDispatch<ApplicationState, Record<string, never>, any>
) => {
   return {
    getUsers: (payload: UserSearchPayload) => {
      dispatch(getUsers(payload));
    },
    getRoles:()=>{
      dispatch(getRoles());
    },
     getHealthPlanMasterResp: () => {
      dispatch(getHealthPlanMasterResp());
    },
    updateUserStatus:(payload: UserStatusPayload)=>{
      dispatch(updateUserStatus(payload));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);